<section id="nspActivation" class="rs-content-wrapper rs-header-has-level2">
  <main id="maincontent" role="main">
    <section class="rs-es-first-section">
      <mprd-back-link></mprd-back-link>
      <div class="row">
        <div class="columns small-12">
          <h1 class="rs-txt-c2 rs-has-subtit" data-cy="nspActivationTitle">
            {{ 'nsp.activation.title' | translate }}
          </h1>
          <div class="rs-panel-big rs-bg-c2 clearfix">
            <h2 class="rs-tit3">{{ 'nsp.activation.subtitle' | translate }}</h2>
            <p data-cy="nspActivationDescription">
              {{ 'nsp.activation.description' | translate }}
            </p>
            <span
              data-cy="nspActivationContent"
              [innerHTML]="'nsp.activation.content' | translate"
            ></span>
            <div class="rs-me"></div>
            <div class="rs-flex-row rs-flex-middle">
              <div class="rs-flex-columns">
                <span
                  data-tooltip
                  tabindex="0"
                  class="has-tip"
                  title="{{ 'nsp.activation.tryandbuy.accessibility' | translate }}"
                >
                  <button
                    type="button"
                    class="rs-patch-promo rs-patch-corner3"
                    data-reveal-id="modal"
                    aria-haspopup="true"
                    data-cy="nspActivationPromoPatch"
                  >
                    <span class="rs-patch-content text-center">
                      {{ 'nsp.activation.tryandbuy.patch' | translate }}
                      <i class="icon-Information-box" aria-hidden="true"></i>
                    </span>
                  </button>
                </span>
                <div
                  aria-labelledby="ac-modal-label"
                  class="reveal-modal"
                  data-reveal=""
                  id="modal"
                  role="dialog"
                >
                  <div class="rs-modal-close">
                    <button class="rs-link-action rs-link-action-close close-reveal-modal">
                      <span class="rs-action-link-icon" [title]="'common.overlayer.close.caption' | translate">
                        <span class="show-for-sr">{{
                          'common.overlayer.close.caption' | translate: true
                        }}</span>
                      </span>
                    </button>
                  </div>
                  <div class="rs-modal-heading">
                    <h2
                      class="rs-modal-heading-title"
                      id="ac-modal-label"
                      data-cy="nspActivationModalTitle"
                    >
                      {{ 'nsp.activation.modal.priceDetails' | translate: true }}
                    </h2>
                  </div>
                  <div
                    class="re-modal-content"
                    [innerHTML]="'nsp.activation.modal.content' | translate: true"
                    data-cy="nspActivationModalContent"
                  ></div>
                </div>
              </div>
              <div class="rs-flex-columns" data-cy="nspActivationPriceAsFrom">
                <p>
                  {{ 'nsp.activation.price.asfrom' | translate }}
                  <span class="rs-price-m">
                    <span class="rs-nowrap"
                      ><span class="rs-euro">€</span
                      ><span class="rs-unit">{{ nspAsFromPriceKey | translate }}</span></span
                    >
                  </span>
                  {{ 'common.perMonth' | translate }}
                </p>
              </div>
            </div>
            <p class="rs-txt-s3 rs-txt-details" data-cy="nspActivationFooter">
              {{ 'nsp.activation.footer' | translate }}
            </p>
            <a
              href="javascript:void(0)"
              (click)="goToNextNspStep()"
              class="rs-btn"
              data-cy="nspActivationContinueButton"
              data-tms-event="button-click"
              data-tms-button-zone="nsp"
              attr.data-tms-button-name="{{ 'nsp.activation.button.continue' | translate }}"
              >{{ 'nsp.activation.button.continue' | translate }}
            </a>
          </div>
        </div>
      </div>
    </section>
  </main>
</section>
